import { defineMessages } from "react-intl";
import { defaultCrudMessages } from "../shared/crud/simple-crud";


const taxConfigurationMessages = defineMessages({
  entityName: {
    id: "taxConfiguration.entityName",
    defaultMessage: "Tax configuration",
  },
  vatPercentagePlaceholder: {
    id: "taxConfiguration.vatPercentage.placeholder",
    defaultMessage: "10",
  },
  amountPerNightPlaceholder: {
    id: "taxConfiguration.amountPerNight.placeholder",
    defaultMessage: "0",
  },
  percentagePlaceholder: {
    id: "taxConfiguration.percentage.placeholder",
    defaultMessage: "0.00",
  },
  minimumAgePlaceholder: {
    id: "taxConfiguration.minimumAge.placeholder",
    defaultMessage: "0-18",
  },
  amountPerNightLabel: {
    id: "taxConfiguration.amountPerNight.label",
    defaultMessage: "Amount per night",
  },
  percentageLabel: {
    id: "taxConfiguration.percentage.label",
    defaultMessage: "Percentage",
  },
  minimumAgeLabel: {
    id: "taxConfiguration.minimumAge.label",
    defaultMessage: "Guest minimum age",
  },
  vatPercentageLabel: {
    id: "taxConfiguration.vatPercentage.label",
    defaultMessage: "Vat percentage",
  },
  cityTaxTypePlaceholder: {
    id: "taxConfiguration.cityTaxType.placeholder",
    defaultMessage: "Select your city tax scheme",
  },
  cityTaxTypeLabel: {
    id: "taxConfiguration.cityTaxType.label",
    defaultMessage: "Select your city tax scheme",
  },
  cityTaxTypePerPersonNight: {
    id: "taxConfiguration.cityTaxType.PerPersonNight",
    defaultMessage: "Charge per person, per night",
  },
  cityTaxTypeRoomStayPercentage: {
    id: "taxConfiguration.cityTaxType.RoomStayPercentage",
    defaultMessage: "Charge a percentage of the room stay",
  },
  cityTaxTypeBalearic: {
    id: "taxConfiguration.cityTaxType.Balearic",
    defaultMessage: "Charge using the balearic scheme",
  },
  roomTypePlaceholder: {
    id: "taxConfiguration.roomType.placeholder",
    defaultMessage: "Select the room type of your property",
  },
  roomTypePlaceLabel: {
    id: "taxConfiguration.roomType.label",
    defaultMessage: "Room type",
  },
});

export const messages = {
  ...defaultCrudMessages,
  ...taxConfigurationMessages,
};


